var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMilgeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10595",
    "data-name": "Group 10595",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34.524,
    height: 29.647,
    viewBox: "0 0 34.524 29.647",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_479",
    "data-name": "Rectangle 479",
    width: 34.524,
    height: 29.647,
    fill: "#99abb3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2822",
    "data-name": "Group 2822",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10616",
    "data-name": "Path 10616",
    d: "M1.821,15.536A15.5,15.5,0,0,1,6.1,6.455L8.735,9.094,9.957,7.871,7.367,5.282A15.469,15.469,0,0,1,16.4,1.749V6.042h1.726V1.749a15.469,15.469,0,0,1,9.031,3.533L24.671,7.768,25.893,8.99l2.535-2.535A15.5,15.5,0,0,1,32.7,15.536H29.071v1.726H32.8a15.453,15.453,0,0,1-3.542,9.862L26.3,24.171l-1.222,1.222,3,3-.008.014,1.2,1.241A17.264,17.264,0,1,0,5,29.395l1.222-1.219-.013-.013L8.8,25.569,7.579,24.346,5.061,26.864a15.438,15.438,0,0,1-3.335-9.6h3.5V15.536Z",
    transform: "translate(0 0)",
    fill: "#99abb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10617",
    "data-name": "Path 10617",
    d: "M25.492,16.97,13.445,18.085a1.383,1.383,0,0,0-.841.512l-1.415,2.1a2.083,2.083,0,0,0,.575,2.139l2.274,1.111a1.421,1.421,0,0,0,.985.028L26,18.9c1.632-.567,1.2-2.257-.5-1.933M14.564,22.284l6.95-3.21-7.619.7-1.038,1.537c0,.072,0,.113,0,.135Zm-1.726-.858,0,.009c0-.009,0-.009,0-.009",
    transform: "translate(1.677 2.553)",
    fill: "#99abb3",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilgeIcon);
export default __webpack_public_path__ + "static/media/milge_icon.aefb85be0278b5dcdb082442b3c4fdc0.svg";
export { ForwardRef as ReactComponent };